module.exports = __webpack_public_path__ + "img/Imunopharm.4d5e1e44.jpg";